export enum PropertySteps {
    OwnedAddressPlan = 'OAP',
    PreviousOwnership = 'PO',
    PropertyUsage = 'PU',
    PurchaseSubjectAddress = 'PSA',
    RefinanceFirstLien = 'RFL',
    RefinanceSecondLien = 'RSL',
    RefinanceOwnedAddress = 'ROA',
    RefinanceSubjectAddress = 'RSA',
    RefinanceType = 'RT'
}